import React, { forwardRef } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";

/**
 * DKNNumericInput — Daikin design system numeric input.
 * Wraps Kendo NumericTextBox.
 *
 * Props:
 *   value     number | null
 *   onChange  (e) => void  — e.value is number | null
 *   label     string
 *   error     string
 *   min       number
 *   max       number
 *   step      number (default: 1)
 *   format    string — Kendo number format (e.g. "n2" for 2 decimals)
 *   spinners  boolean (default: true)
 *   fullWidth boolean (default: false)
 *   disabled  boolean
 */
const DKNNumericInput = forwardRef(function DKNNumericInput(
  {
    value,
    onChange,
    label,
    error,
    min,
    max,
    step = 1,
    format,
    spinners = true,
    fullWidth = false,
    disabled = false,
    placeholder,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <NumericTextBox
        ref={ref}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        format={format}
        spinners={spinners}
        disabled={disabled}
        placeholder={placeholder}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNNumericInput;
